import { FormControlLabel, Switch } from '@mui/material';
import { useIsSupplierPortalProductEditorFieldDisabled } from 'hooks/useUserState_utils';

import { useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const InStockField: React.FC = () => {
  const { t } = useTranslation();
  const { field } = useController({
    name: 'private_attributes.data.inStock',
    defaultValue: true
  });
  const disabled = useIsSupplierPortalProductEditorFieldDisabled();

  return (
    <FormControlLabel
      control={
        <Switch
          color="success"
          checked={field.value ?? true}
          onChange={field.onChange}
          disabled={disabled}
        />
      }
      label={t('forms.product.inStock.label')}
    />
  );
};
